import { render, staticRenderFns } from "./YieldManagementRegistraionModal.vue?vue&type=template&id=5cf0bc16&scoped=true&"
import script from "./YieldManagementRegistraionModal.vue?vue&type=script&lang=js&"
export * from "./YieldManagementRegistraionModal.vue?vue&type=script&lang=js&"
import style0 from "./YieldManagementRegistraionModal.vue?vue&type=style&index=0&id=5cf0bc16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0bc16",
  null
  
)

export default component.exports